var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropfile"},[_c('textarea',{staticClass:"form-control ",attrs:{"rows":25,"placeholder":"Drop a  file here."}})])}
var staticRenderFns = []

export { render, staticRenderFns }